import classNames from "classnames";
import { useFormik } from "formik";
import { AscButton } from "../../components";
import AscTextInput from "../../components/AscInputFields/AscTextInput/AscTextInput";
import AscLink from "../../components/AscLink/AscLink";
import AscHeading from "../../components/AscTypography/AscHeading/AscHeading";
import AscParagraph from "../../components/AscTypography/AscParagraph/AscParagraph";
import AscAuthFlowLayout from "../AscAuthFlowLayout/AscAuthFlowLayout";
import styles from "./AscForgotPasswordView.module.scss";
import * as Yup from "yup";

export interface AscForgotPasswordViewProps {
  className?: string;
  signInLink: string;
  onSendVerificationLink: (email:string) => void;
}

export default function AscForgotPasswordView({
  className,
  signInLink,
  onSendVerificationLink,
}: AscForgotPasswordViewProps) {
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    onSubmit: (values) => {
      onSendVerificationLink(values?.email);
    },
  });

  return (
    <AscAuthFlowLayout alignment="right" roundSideImage>
      <form
        onSubmit={formik?.handleSubmit}
        data-testid="asc-send-verification-code-view"
        className={classNames(styles.ground, className)}
      >
        <header className={styles.heading}>
          <AscHeading className={styles.title} level={1}>
            Forgot your password?
          </AscHeading>
          <AscParagraph className={styles.subTitle}>
            Enter your email and we'll send you instructions
          </AscParagraph>
        </header>

        <div className={styles.form}>
          <div className={styles.fieldGroup}>
            <label className={styles.fieldLabel} htmlFor="email">
              Email
            </label>
            <AscTextInput
              className={styles.inputField}
              placeholder="Enter your email"
              id="email"
              name="email"
              data-testid="asc-send-verification-code-email"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            {formik.errors.email && formik.touched.email && (
              <div className={styles.fieldError}>{formik.errors.email}</div>
            )}
          </div>
        </div>

        <footer className={styles.footer}>
          <AscButton
            className={styles.footerButton}
            variant="primary"
            size="large"
            fullWidth
            type="submit"
            data-testid="asc-send-verification-code-submit"
          >
            Send verification code
          </AscButton>

          <div className={styles.signInPrompt}>
            Back to{" "}
            <AscLink
              className={styles.signInLink}
              href={signInLink}
              innerWrapperTag="button"
            >
              Sign in
            </AscLink>
          </div>
        </footer>
      </form>
    </AscAuthFlowLayout>
  );
}
